import React, { Component } from 'react';
import { bool, func, string } from 'prop-types';
import './RuleNameDisplay.scss';

class RuleNameDisplay extends Component {
  static propTypes = {
    ruleName: string,
    startEditingRuleName: func
  };

  render() {
    const { ruleName, startEditingRuleName } = this.props;

    return (
      <div className="edit__name">
        {ruleName}
        <i className="edit__icon icon-pencil" onClick={startEditingRuleName} />
      </div>
    );
  }
}

export default RuleNameDisplay;
